import useOrganizationsStore from "@lib/store/organization";
import type { RouteLocationNormalizedGeneric } from "vue-router";
import type { TOrganization } from "~/composables/advisor/organizations-api";
import { MINAINNEHAV_ORG } from "~/constants/org";
import { PUBLIC_ROUTES } from "~/constants/routes";

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalizedGeneric) => {
  const $router = useRouter();
  const { $auth } = useNuxtApp();
  const orgStore = useOrganizationsStore();

  if ($auth.loggedIn && !PUBLIC_ROUTES.includes(to.name as string) && to.name !== "advisor" && to.name !== "advisor-index") {
    let orgs = orgStore.organizations;
    if (!orgs || !orgs.length) {
      await orgStore.fetchOrganizations();
    }
    orgs = orgStore.organizations;
    const org = orgs.find((org: TOrganization) => org.public_id === MINAINNEHAV_ORG);
    if (!org) {
      orgStore.setSelectedOrganization(null);
      return $router.replace({ path: "/advisor" });
    }
    orgStore.setSelectedOrganization(org);
  }
});
